import Hero from "../components/Hero";
import Body from "../components/Body";

function Home() {
  return (
    <>
      <Hero />
      <Body />
    </>
  );
}

export default Home;
